
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock, AlertTriangle } from "lucide-react";
import { format } from "date-fns";

interface LoginAttempt {
  id: string;
  success: boolean;
  attempted_at: string;
  ip_address: string;
  failure_reason: string | null;
}

interface LoginActivityProps {
  loginAttempts: LoginAttempt[];
  isLoadingAttempts: boolean;
}

const LoginActivity = ({ loginAttempts, isLoadingAttempts }: LoginActivityProps) => {
  const failedAttempts = loginAttempts.filter(attempt => !attempt.success);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5" />
          Login Activity
        </CardTitle>
      </CardHeader>
      <CardContent>
        {failedAttempts.length > 0 && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <div className="flex items-center gap-2 text-red-800">
              <AlertTriangle className="h-4 w-4" />
              <span className="font-medium">
                {failedAttempts.length} failed login attempt(s) detected
              </span>
            </div>
          </div>
        )}
        
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {isLoadingAttempts ? (
            <p className="text-sm text-gray-500">Loading...</p>
          ) : loginAttempts.length > 0 ? (
            loginAttempts.map((attempt) => (
              <div key={attempt.id} className="flex items-center justify-between p-3 border rounded-lg">
                <div className="flex items-center gap-3">
                  <Badge variant={attempt.success ? "default" : "destructive"}>
                    {attempt.success ? "Success" : "Failed"}
                  </Badge>
                  <div>
                    <p className="text-sm font-medium">
                      {format(new Date(attempt.attempted_at), 'MMM dd, yyyy HH:mm')}
                    </p>
                    <p className="text-xs text-gray-500">
                      {attempt.ip_address}
                    </p>
                  </div>
                </div>
                {attempt.failure_reason && (
                  <span className="text-xs text-red-600">
                    {attempt.failure_reason}
                  </span>
                )}
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500">No login activity recorded</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default LoginActivity;
